import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as chimeActions from 'store/chime/chimeActions';

ExitMeetingDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default function ExitMeetingDialog(props) {
  const { open, setOpen } = props;
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const { isHost } = useSelector(({ chime }) => ({ isHost: chime.isHost }));

  const exitMeeting = () => dispatch(chimeActions.leaveRoomAction());

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{`Are you sure you want to ${
          isHost ? 'end' : 'leave'
        } the meeting?`}</DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions style={{ display: 'flex', flexGrow: 1, justifyContent: 'space-between' }}>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={exitMeeting} variant="contained" color="primary" autoFocus>
            {isHost ? 'End Meeting For All' : 'Leave Meeting'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
